export default __webpack_public_path__ + "static/media/라탄클래스_웹.ec80d500.jpg";